import React from "react"
import PPUtils from "../../utils/PPUtils"

function KpiStrip({ stats, t }) {
    const cheaperColor = PPUtils.Colors.GreenStart

    return (
        <div className="row mb-3">
            <div className="col-6 col-md-3 mb-2">
                <div className="pp-stats-kpi">
                    <div className="kpi-label">{t("statistic.kpi_products")}</div>
                    <div className="kpi-value">{stats?.activeProducts?.toLocaleString?.() ?? stats?.activeProducts ?? "–"}</div>
                </div>
            </div>
            <div className="col-6 col-md-3 mb-2">
                <div className="pp-stats-kpi">
                    <div className="kpi-label">{t("statistic.kpi_shops")}</div>
                    <div className="kpi-value">{stats?.activeShops ?? "–"}</div>
                </div>
            </div>
            <div className="col-6 col-md-3 mb-2">
                <div className="pp-stats-kpi">
                    <div className="kpi-label">{t("statistic.kpi_cheaper")}</div>
                    <div className="kpi-value" style={{ color: cheaperColor }}>
                        {(stats?.productsPriceLower ?? 0).toFixed(1)}%
                    </div>
                </div>
            </div>
            <div className="col-6 col-md-3 mb-2">
                <div className="pp-stats-kpi">
                    <div className="kpi-label">{t("statistic.kpi_crawls_today")}</div>
                    <div className="kpi-value">{stats?.crawlsToday?.toLocaleString?.() ?? stats?.crawlsToday ?? "–"}</div>
                </div>
            </div>
        </div>
    )
}

export { KpiStrip }
